import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { CustomSelectComponent } from '@/components/custom-select/custom-select.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { PayMethodFormComponent } from '@/pages/pay-methods/pay-method-form/pay-method-form.component';
import { Utils } from '@/utils/utils';
import { COUNTRIES } from '@/utils/countries';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
  selector: 'app-provider-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    CustomSelectComponent,
    LoadingComponent,
  ],
  templateUrl: './provider-form.component.html',
  styleUrl: './provider-form.component.scss',
})
export class ProviderFormComponent {
  @Input() id: number | string = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  public showModalImage = false

  public dropdowns: any = {
    countries: COUNTRIES,
  }

  public showOptionalFields = false;

  public payMethodFormComponent = PayMethodFormComponent

  private codeRetryCount = 0;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getDropdowns();

    if (this.id != 0) {
      this.getById(this.id);
    } else {
      this.getIdByCompany();
    }
  }

  acceptFormFunction() {
    this.saveEntity()
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  createForm() {
    this.saveForm = new FormGroup({
      // Datos Identificativos
      id_by_company: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
      code: new FormControl(null),
      nif: new FormControl(null),
      accounting_account: new FormControl(null),
      commercial_claim: new FormControl(null),

      // Dirección y Localización
      address: new FormControl(null),
      city: new FormControl(null),
      post_office_box: new FormControl(null),
      province: new FormControl(null),
      postal_code: new FormControl(null),
      country: new FormControl('ES'), // Valor por defecto: España

      // Contacto
      email: new FormControl(null, [Validators.email]),
      phone_1: new FormControl(null),
      phone_2: new FormControl(null),
      contact_person: new FormControl(null),

      payment_method_id: new FormControl(null),
      note: new FormControl(null),
    })
  }

  toggleOptionalFields() {
    this.showOptionalFields = !this.showOptionalFields;
  }

  getById(id: number | string) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.providers, id).subscribe({
      next: (data: any) => {
        this.saveForm.patchValue(data.provider);
        this.loading.set(false);

        this.showOptionalFields = true;

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('ERROR obtener productos. ' + error);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  getIdByCompany() {
    this.apiService.getPetition(Urls.urls.providers + '/last-id-by-company').subscribe((data: any) => {
      this.saveForm.patchValue({ id_by_company: data.last_id_by_company + 1 });
      this.saveForm.patchValue({ code: String(data.last_id_by_company + 1).padStart(3, '0') });
      this.cdr.detectChanges();
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.providers, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success("Proveedor guardado")
          this.codeRetryCount = 0;
          this.acceptFunction.emit(response);
          this.closeFormFunction()
        },
        error: (error: any) => {
          if (Utils.isCodeAlreadyTakenError(error) && this.codeRetryCount < Utils.MAX_CODE_ALREADY_TAKEN_RETRIES) {
            this.codeRetryCount++;
            this.saveForm.get('code')?.setValue(Utils.incrementCode(this.saveForm.get('code')?.value));
            this.saveEntity();
            return;
          }

          this.codeRetryCount = 0;
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar el proveedor")
        },
        complete: () => {
          this.saving.set(false);
        }
      })
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

  getDropdowns() {
    this.apiService.getSelectors(Urls.urls.selectors, {  pay_methods: {} }).subscribe((data: any) => {
      this.dropdowns = { ...data, countries: COUNTRIES }
      this.cdr.detectChanges();
    });
  }

}
